import { createSelector } from 'reselect'
import initParametersSelector from '../initParametersSelector'

const isAveStringFramePostMessageHackEnabledSelector = createSelector(
    initParametersSelector,
    (initParameters): boolean => initParameters.features?.includes('enableAvePostMessage'),
)

export default isAveStringFramePostMessageHackEnabledSelector
